import React from "react";
import img2 from "../../../assets/banner/banner2.webp";
import { Container } from "react-bootstrap";
import "./banner.css";

export default function Banner() {
  return (
    <>
      <Container className="p-0" fluid>
        <div className="main-div">
        <img src={img2} className="img-fluid w-100" alt="home-banner" />
        </div>
      </Container>
    </>
  );
}
